import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { validation, formfields } from "kea-react"
import { LimiteGuias, importeMayorCero } from "../guias/listados/guias/list/filtro";
import { FolioGuia } from "app/features/componentes/folioguia";

type Entity = models.FiltroGuia;
export interface State {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
export class ReporteConsultaGuias extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {
                EsReporteConsultaGuias: true
            } as Entity
        };
    }

    errors = () => validation.getErrors(this.rules, this.state.value);
    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x })
    }), this.errors);

    get rules(): validation.Rules<Entity> {
        return {
        };
    }


    private onFechaDesdeChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(0, 0, 0, 0);
            const viejo = this.state.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaInicio: fecha };
            const nuevo = { ...viejo, ...cambioFecha };
            this.setState({ value: nuevo });
        } else {
            const viejo = this.state.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaInicio: null };
            const nuevo = { ...viejo, ...cambioFecha };
            this.setState({ value: nuevo });
        }
    }

    private onFechaHastaChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(23, 59, 59);
            const viejo = this.state.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaFinal: fecha };
            const nuevo = { ...viejo, ...cambioFecha };
            this.setState({ value: nuevo });
        } else {
            const viejo = this.state.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaFinal: null };
            const nuevo = { ...viejo, ...cambioFecha };
            this.setState({ value: nuevo });
        }
    }

    onGenerarReporte = async () => {
        if( this.state.value.EsDeCreditoVaciasStr == null) {
            this.state.value.EsDeCreditoVacias = false;
            this.state.value.EsDeCredito = null;
        } else if( this.state.value.EsDeCreditoVaciasStr == "Vacías") {
            this.state.value.EsDeCreditoVacias = true;
            this.state.value.EsDeCredito = null;
        } else if( this.state.value.EsDeCreditoVaciasStr == "Si") {
            this.state.value.EsDeCreditoVacias = false;
            this.state.value.EsDeCredito = true;
        } else if( this.state.value.EsDeCreditoVaciasStr == "No") {
            this.state.value.EsDeCreditoVacias = false;
            this.state.value.EsDeCredito = false;
        }

        const guiasDoc = await resources.RepConsultaGuias.Generar(this.state.value);
        await kea.download(guiasDoc, "Reporte consulta de guías.xls");
    }

    private filtro = (props: State) => props.value;

    render() {
        const verClienteOrigen = false;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const Datetime = getField(kea.DateTime);
        const Cliente = getField(selectores.Cliente);
        const Sucursal = getField(selectores.Sucursal);
        const Folio = getField(FolioGuia);
        const StatusFacturacion = getField(selectores.StatusFacturacion);
        const StatusGuia = getField(selectores.StatusGuia);
        const SiNo = getField(selectores.SiNo);
        const Importe = getField(importeMayorCero);
        const Acuse = getField(selectores.TipoAcuse);
        const Limite = getField(LimiteGuias);
        const TipoSeguro = getField(selectores.TipoSeguro);
        const SiNoVacio = getField(selectores.SiNoVacias);

        return (
            <div>
                <kea.Title titulo="Reporte de consultas de guías" onRegresar={() => history.go("../")} />

                {kea.autogrid(2, [
                    <Sucursal field="IdSucursalStatus" label="Sucursal actual" />,
                    <Sucursal field="IdSucursalOrigen" label="Sucursal origen" />,
                    <Sucursal field="IdSucursalDestino" label="Sucursal destino" />,
                    <Datetime field="FechaInicio" onChange={this.onFechaDesdeChange} label="Fecha de creación (inicio)" />,
                    <Datetime field="FechaFinal" onChange={this.onFechaHastaChange} label="Fecha de creación (final)" />,
                    <Cliente field="IdClienteDestino" label="Cliente destino" />,
                    verClienteOrigen ? <Cliente field="IdClienteOrigen" label="Cliente origen" /> : null,
                    <Folio field="Folio" />,
                    // <StatusFacturacion field="StatusGuiaFacturacion" label="Status guía facturación" />,
                    <StatusGuia field="Status" label="Status" />,
                    <Number field="CantPaquetes" label="Paquetes" />,
                    <Number field="CantSobres" label="Sobres" />,

                    <SiNo field="FletePorCobrar" label="FXC" />,
                    <SiNo field="EntregaDomicilio" label="EAD" />,
                    <SiNo field="RecoleccionDomicilio" label="RAD" />,
                    <Acuse field="TipoAcuse" label="Acuse" />,
                    <Importe field="ImporteMayorCero" label="Importe total" />,
                    <SiNo field="EsCancelada" label="Cancelada" />,
                    //<SiNo field="EsDeCredito" label="De crédito" />,
                    <SiNoVacio field="EsDeCreditoVaciasStr" label="De crédito" />,
                    <SiNo field="StatusGuiaFacturacion" label="Facturadas" />
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Generar reporte" style="success" onClick={this.onGenerarReporte} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteconsultaguias/index.tsx